// QRCodeFloatButton.js
// 从 App.js 抽取出的「右下角小程序二维码悬浮按钮」组件
// 原本在学单词/学用法页面才有，现在抽成公共组件，学句子页面等也可以直接复用

import React from 'react';

function QRCodeFloatButton({ greenScreen, theme, showQRCode, setShowQRCode }) {
  return (
    <div
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        zIndex: 9998,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      {/* 展开的二维码卡片 */}
      {showQRCode && (
        <div style={{
          marginBottom: '10px',
          background: greenScreen ? 'rgba(0,0,0,0.6)' : 'white',
          borderRadius: '12px',
          padding: '12px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
          textAlign: 'center',
          animation: 'fadeInUp 0.2s ease-out',
          border: greenScreen ? '1px solid rgba(255,255,255,0.3)' : '1px solid #eee',
        }}>
          <img
            src="/images/miniapp-qrcode.png"
            alt="小程序二维码"
            style={{
              width: '140px',
              height: '140px',
              display: 'block',
              borderRadius: '8px',
            }}
          />
          <p style={{
            margin: '8px 0 2px 0',
            fontSize: '0.85em',
            fontWeight: '700',
            color: greenScreen ? '#ffffff' : '#333',
            textShadow: greenScreen ? '1px 1px 3px rgba(0,0,0,0.9)' : 'none',
          }}>
            微信扫码体验小程序
          </p>
          <p style={{
            margin: '2px 0 0 0',
            fontSize: '0.75em',
            color: greenScreen ? 'rgba(255,255,255,0.8)' : '#999',
            textShadow: greenScreen ? '1px 1px 3px rgba(0,0,0,0.9)' : 'none',
          }}>
            削掉已会 只学不会
          </p>
        </div>
      )}

      {/* 触发按钮 */}
      <button
        onClick={() => setShowQRCode(prev => !prev)}
        style={{
          width: '48px',
          height: '48px',
          borderRadius: '50%',
          background: greenScreen
            ? 'rgba(0,0,0,0.5)'
            : (theme === 'dark' ? '#333' : '#1890ff'),
          border: greenScreen ? '2px solid rgba(255,255,255,0.6)' : 'none',
          color: 'white',
          fontSize: '1.4em',
          cursor: 'pointer',
          boxShadow: '0 2px 12px rgba(0,0,0,0.2)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'transform 0.2s',
        }}
        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
        title={showQRCode ? '收起二维码' : '扫码体验小程序'}
      >
        📱
      </button>
    </div>
  );
}

export default QRCodeFloatButton;
